export const AppConfig = {
  projectName: process.env.REACT_APP_PROJECT_NAME || "VelaKoda",
  apiBaseUrl: process.env.REACT_APP_API_URL,
  serverUrl: process.env.REACT_APP_SERVER_URL,
};
